import { Instagram, Facebook, Mail } from "lucide-react";

export default function Footer() {
  return (
    <footer
      id="contact"
      data-testid="footer"
      className="relative bg-[#0A0A0A] text-[#F5F0E8] border-t-[3px] border-[#C41E1E] overflow-hidden"
    >
      <div className="max-w-[1800px] mx-auto px-6 md:px-12 lg:px-16 pt-20 md:pt-28 pb-10">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-12 lg:gap-16">
          {/* Left: brand + visit */}
          <div className="lg:col-span-5">
            <span className="overline">The Arc Institute</span>
            <p className="mt-4 font-serif-display text-3xl md:text-4xl leading-tight">
              Chamberbrook Arts District
              <br />
              <span className="italic text-[#F5F0E8]/80">
                Richmond, Virginia
              </span>
            </p>
            <address className="mt-6 not-italic text-[#F5F0E8]/70 leading-relaxed">
              Chamberlayne Avenue
              <br />
              Richmond, VA
              <br />
              Tuesday — Sunday · 11:00 – 18:00
            </address>
            <a
              href="mailto:info@arcinstituteglobal.org"
              data-testid="footer-email"
              className="pl-link mt-6 inline-flex items-center gap-3 text-[11px] uppercase tracking-[0.3em]"
            >
              <Mail size={14} /> info@arcinstituteglobal.org
            </a>
          </div>

          {/* Middle: links */}
          <div className="lg:col-span-4 grid grid-cols-2 gap-8">
            <div>
              <span className="overline text-[#F5F0E8]/60">Exhibition</span>
              <ul className="mt-4 space-y-3 text-sm">
                <li>
                  <a href="#exhibition" className="pl-link">
                    Overview
                  </a>
                </li>
                <li>
                  <a href="#artist" className="pl-link">
                    The Artist
                  </a>
                </li>
                <li>
                  <a href="#gallery" className="pl-link">
                    The Gallery
                  </a>
                </li>
                <li>
                  <a href="#journey" className="pl-link">
                    The Journey
                  </a>
                </li>
              </ul>
            </div>
            <div>
              <span className="overline text-[#F5F0E8]/60">Resources</span>
              <ul className="mt-4 space-y-3 text-sm">
                <li>
                  <a href="#" className="pl-link">
                    Press Kit
                  </a>
                </li>
                <li>
                  <a href="#updates" className="pl-link">
                    Field Notes
                  </a>
                </li>
                <li>
                  <a href="#newsletter" className="pl-link">
                    Newsletter
                  </a>
                </li>
                <li>
                  <a href="#" className="pl-link">
                    Support
                  </a>
                </li>
              </ul>
            </div>
          </div>

          {/* Right: socials & RSVP */}
          <div className="lg:col-span-3">
            <span className="overline text-[#F5F0E8]/60">Connect</span>
            <div className="mt-4 flex items-center gap-4">
              {[
                {
                  icon: Instagram,
                  label: "Instagram",
                  href: "https://www.instagram.com/arcinstituteglobal",
                },
                {
                  icon: Facebook,
                  label: "Facebook",
                  href: "https://www.facebook.com/share/1BgiSsLr2m/",
                },
              ].map(({ icon: Icon, label, href }) => (
                <a
                  key={label}
                  href={href}
                  target="_blank"
                  rel="noopener noreferrer"
                  aria-label={`ARC Institute on ${label}`}
                  data-testid={`footer-social-${label.toLowerCase()}`}
                  className="w-11 h-11 flex items-center justify-center border border-[#F5F0E8]/30 hover:border-[#C41E1E] hover:text-[#C41E1E] transition-colors"
                >
                  <Icon size={16} />
                </a>
              ))}
            </div>
            <a
              href="#newsletter"
              data-testid="footer-rsvp-btn"
              className="mt-8 pl-cta pl-cta-primary"
            >
              Follow the Journey
            </a>
          </div>
        </div>

        {/* Massive type */}
        <div className="mt-20 md:mt-28 border-t border-[#F5F0E8]/15 pt-8 overflow-hidden">
          <h3
            className="font-serif-display font-bold leading-none tracking-tighter text-[#F5F0E8] text-[22vw] md:text-[16vw]"
            aria-hidden="true"
          >
            The<span className="text-[#C41E1E]"> </span>
            <span className="italic font-normal">Arc</span>
          </h3>
        </div>

        <div className="mt-8 flex flex-col md:flex-row md:items-center md:justify-between gap-4 text-[11px] uppercase tracking-[0.25em] text-[#F5F0E8]/55">
          <p>
            © 2026 The Arc Institute · Première Ligne / First Line: A
            People's Witness
          </p>
          <p>
            Photographs © Abdou Karim Ndoye · Richmond, Virginia
          </p>
        </div>
      </div>
    </footer>
  );
}
